import { tutorials } from "../config/tutorials";

export const tutorialsConsult = () => {
    return tutorials.tutorialsConsult().then(response => response)
};